/*
 * Copyright (c) All right reserved Anvish Inc. 2026
 * This project and any portion thereof may not be reproduced or used in any manner without the express written permission of Anvish Inc.
 */

"use client";
import React from "react";
import { usePathname } from "next/navigation";

import NonAuthNavbar from "@/components/layout/navbar/NonAuthNavbar";

interface RouteBasedNavbarProps {
  csrfToken: any;
  navbarData: any;
}

const RouteBasedNavbar: React.FC<RouteBasedNavbarProps> = ({
  csrfToken,
  navbarData,
}) => {
  const currentPathName = usePathname();

  const isDashboardPage = currentPathName.startsWith("/dashboard");
  const isAuthPage = currentPathName.startsWith("/auth");

  return (
    <div>
      {!isDashboardPage && !isAuthPage && (
        <NonAuthNavbar csrfToken={csrfToken} navbarData={navbarData} />
      )}
    </div>
  );
};

export default RouteBasedNavbar;
